import { render } from "./SiteComponent.vue?vue&type=template&id=78535cc2"
import script from "./SiteComponent.vue?vue&type=script&lang=js"
export * from "./SiteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Site/SiteComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78535cc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78535cc2', __exports__)) {
    api.reload('78535cc2', __exports__)
  }
  
  module.hot.accept("./SiteComponent.vue?vue&type=template&id=78535cc2", () => {
    api.rerender('78535cc2', render)
  })

}


export default __exports__